import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, CardBody, Badge, Button } from 'reactstrap'
import './DefaultDashboard.css'
import AlertTrendChartTalkpool from '../../components/AlertTrendChartTalkpool'
import WorkPermitSection from '../../components/WorkPermitSection'
import talpoolService from '../../../../api/talkpool'
import { errorToast } from '../../../../_helper/helper'
import { AlertsCard } from '../../components/AlertsCard'
import { getCurrentWeekWithYear } from '../../../../utils/currentWeekWithYear'
import FiltersComponent from '../../../IF/pages/components/Filters/FiltersComponent'
import Loader from '../../components/Loader'
import NewPagination from '../../../Screens/GlobalUser/CameraConfigurations/Components/pagination/NewPagination'
import { AlertCircle } from "react-feather";
import ImageZoomSingleImage from '../../../Dashboards/AreaDashbaord/reports/Components/LiveAlertsCards/ImageZoomSingleImage';

const LOCAL_STORAGE_KEY = 'defaultPageFilters';
const ALERTS_PER_PAGE = 12; // Change as needed
const DefaultDashboard = () => {

  //filters logic start
  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
        selectDate: 'week',
        time: '',
        week: getCurrentWeekWithYear(),
        date: '',
        month: '',
        shift: '',
        starting: '',
        ending: ''
      };
  };

  const [filters, setFilters] = useState(getInitialFilters);
  const [callApi, setCallApi] = useState(false); // 🔁 API trigger

  const handleSave = () => {
    const updatedFilters = {
      selectDate: filters.selectDate,
      time: '',
      week: '',
      date: '',
      month: '',
      shift: filters.shift,
      starting: '',
      ending: '',
    };

    switch (filters.selectDate) {
      case 'date':
        if (!filters.date) return errorToast('Please select a Date!');
        updatedFilters.date = filters.date;
        break;
      case 'week':
        if (!filters.week) return errorToast('Please select a Week!');
        updatedFilters.week = filters.week;
        break;
      case 'month':
        if (!filters.month) return errorToast('Please select a Month!');
        updatedFilters.month = filters.month;
        break;
      case 'custom':
        if (!filters.starting || !filters.ending)
          return errorToast('Please select both Starting and Ending Dates!');
        updatedFilters.starting = filters.starting;
        updatedFilters.ending = filters.ending;
        break;
      default:
        break;
    }

    setFilters(updatedFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
    setCallApi(prev => !prev); // 🔁 Trigger API calls
  };

  const handleCancel = () => {
    const defaultFilters = {
      selectDate: 'week',
      time: '',
      week: getCurrentWeekWithYear(),
      date: '',
      month: '',
      shift: '',
      starting: '',
      ending: ''
    };

    setFilters(defaultFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(defaultFilters));
    setCallApi(prev => !prev); // 🔁 Reset to default triggers API
  };

  //filters logic end

  const [alertsData, setAlertsData] = useState([])
  const [camerasData, setCamerasData] = useState([])
  const [statsData, setStatsData] = useState([])
  const [alertTrend, setALertTrendData] = useState()
  const [permitData, setPermitData] = useState({
    authorized: 0, unAuthorized: 0
  })

  //zoom image start
  const [showModal, setShowModal] = useState(false);
  const [imageUrl, setImageurl] = useState();
  const handleImageClick = (photo, cameraDetails) => {
    console.log('photttt', photo)
    setImageurl(photo);
    setCameraDetails(cameraDetails);
    setShowModal(!showModal);
  };

  const [cameraDetails, setCameraDetails] = useState(null);
  //zoom image End
  // Loading states
  const [loadingStats, setLoadingStats] = useState(false)
  const [loadingAlertTrend, setLoadingAlertTrend] = useState(false)
  const [loadingAlerts, setLoadingAlerts] = useState(false)
  const [loadingCameras, setLoadingCameras] = useState(false)

  // First load tracking
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  // Pagination state for alerts
  const [alertsPage, setAlertsPage] = useState(0);
  const [totalPages, setTotalPages] = useState()




  const get_live_alerts = async (showLoader = true) => {
    if (showLoader) setLoadingAlerts(true)
    try {
      const payload = {
        client_id: 21,
        factory_id: 20,
        module_ids: [],
        zone_ids: [3, 4, 5],
        area_ids: [],
        sub_area_ids: [],
        filters: {
          date: filters?.date,
          week: filters?.week,
          month: filters?.month,
          starting: filters?.starting,
          ending: filters?.ending
        },
        pagination: {
          page_no: alertsPage,
          per_page: ALERTS_PER_PAGE
        }
      }
      const res = await talpoolService.get_live_alerts(payload)
      if (res) {
        console.log('ressss111', res)
        setAlertsData(res?.data?.data?.alerts)
        setTotalPages(res?.data?.data?.pagination?.total_pages)
      } else {
        errorToast('alerts data Error')
      }
    } catch (err) {
      console.log('alerts data error', err)
    } finally {
      if (showLoader) setLoadingAlerts(false)
    }
  }
  const get_alert_trend = async (showLoader = true) => {
    if (showLoader) setLoadingAlertTrend(true)
    try {
      const payload = {
        filter_type: filters?.selectDate,
        client_id: 21,
        factory_id: 20,
        module_ids: [],
        zone_ids: [],
        filters: {
          date: filters?.date,
          week: filters?.week,
          month: filters?.month,
          starting: filters?.starting,
          ending: filters?.ending
        }
      }
      const res = await talpoolService.get_alert_trend(payload)
      if (res) {
        setALertTrendData(res?.data?.data)
      } else {
        errorToast('alerts data Error')
      }
    } catch (err) {
      console.log('alerts data error', err)
    } finally {
      if (showLoader) setLoadingAlertTrend(false)
    }
  }
  const get_stats = async (showLoader = true) => {
    if (showLoader) setLoadingStats(true)
    try {
      const payload = {
        client_id: 21,
        factory_id: 20,
        module_ids: [],
        zone_ids: [],
        filters: {
          date: filters?.date,
          week: filters?.week,
          month: filters?.month,
          starting: filters?.starting,
          ending: filters?.ending
        }
      }
      const res = await talpoolService.get_stats(payload)
      if (res) {
        const updatedData = res?.data?.data;
        const authorized = res?.data?.data?.unauthorize_alerts
        const unAuthorized = res?.data?.data?.working_on_site_alerts
        setPermitData({
          authorized,
          unAuthorized
        })
        console.log('updatedData', updatedData)
        const updatedStats = dashboardStats.map(item => {
          // agar total_cameras hai to subtitle update karo
          if (item.id === "total_cameras") {
            return {
              ...item,
              value: updatedData[item.id] ?? item.value,
              subtitle: `${updatedData.active_cameras ?? 0} online`
            };
          }

          // baki items normal update honge
          return {
            ...item,
            value: updatedData[item.id] ?? item.value,
          };
        });

        setStatsData(updatedStats);
      } else {
        errorToast('alerts data Error')
      }
    } catch (err) {
      console.log('alerts data error', err)
    } finally {
      if (showLoader) setLoadingStats(false)
    }
  }
  const get_cameras = async (showLoader = true) => {
    if (showLoader) setLoadingCameras(true)
    try {
      const payload = {
        client_id: 21,
        factory_id: 20,
        window_time_minutes: 15
      }
      const res = await talpoolService.check_cameras_status(payload)
      if (res) {
        setCamerasData(res?.data?.data?.cameras_list)
      } else {
        errorToast('alerts data Error')
      }
    } catch (err) {
      console.log('alerts data error', err)
    } finally {
      if (showLoader) setLoadingCameras(false)
    }
  }

  // Initial load when filters change
  useEffect(() => {
    setIsFirstLoad(true)
    get_alert_trend(true) // Show loader on first load
    get_cameras(true) // Show loader on first load
    get_stats(true) // Show loader on first load

    // Set first load to false after initial calls
    setTimeout(() => setIsFirstLoad(false), 1000)
  }, [callApi])

  useEffect(() => {
    setIsFirstLoad(true)
    get_live_alerts(true) // Show loader on first load

    // Set first load to false after initial call
    setTimeout(() => setIsFirstLoad(false), 1000)
  }, [callApi, alertsPage])

  // Auto-refresh intervals for all four APIs (every 3 seconds)
  useEffect(() => {
    if (isFirstLoad) return // Don't start intervals during first load

    const alertTrendInterval = setInterval(() => {
      get_alert_trend(false) // No loader for background updates
    }, 3000)

    const statsInterval = setInterval(() => {
      get_stats(false) // No loader for background updates
    }, 3000)

    const alertsInterval = setInterval(() => {
      get_live_alerts(false) // No loader for background updates
    }, 3000)

    const camerasInterval = setInterval(() => {
      get_cameras(false) // No loader for background updates
    }, 3000)

    // Cleanup intervals on unmount or when dependencies change
    return () => {
      clearInterval(alertTrendInterval)
      clearInterval(statsInterval)
      clearInterval(alertsInterval)
      clearInterval(camerasInterval)
    }
  }, [isFirstLoad, filters, alertsPage]) // Restart intervals when filters or page changes

  // Static data for dashboard cards
  const dashboardStats = [
    {
      id: 'total_cameras',
      title: 'Total Cameras',
      value: '0',
      subtitle: '',
      icon: '📹',
      color: 'primary'
    },
    {
      id: 'total_alerts',
      title: 'New Alerts',
      value: '0',
      subtitle: 'Detected',
      icon: '🚨',
      color: 'warning'
    },
    {
      id: 'active_ai_models',
      title: 'AI Models Active',
      value: '0',
      subtitle: 'All models operational',
      icon: '🤖',
      color: 'success'
    },
    {
      id: 'ppe_alerts',
      title: 'PPE Compliance Alerts',
      value: '0',
      subtitle: 'Detected',
      icon: '🦺',
      color: 'info'
    },
    {
      id: 'unauthorize_alerts',
      title: 'unAuthorized Access',
      value: '0',
      subtitle: 'Detected',
      icon: '🚫',
      color: 'danger'
    },
    {
      id: 'working_on_site_alerts',
      title: 'Working On Site',
      value: '0',
      subtitle: 'Working',
      icon: '🏭',
      color: 'danger'
    }
  ]

  // Static data for camera feeds
  const cameraFeeds = [
    {
      id: 1,
      name: 'Main Entrance',
      status: 'Online',
      image: 'https://smartclick.ai/wp-content/uploads/2022/02/Helmet-detection.png',
      statusColor: 'success'
    },
    {
      id: 2,
      name: 'Warehouse A',
      status: 'Online',
      image: 'https://smartclick.ai/wp-content/uploads/2022/02/Helmet-detection.png',
      statusColor: 'success'
    },
    {
      id: 3,
      name: 'Production Line 1',
      status: 'Offline',
      image: 'https://smartclick.ai/wp-content/uploads/2022/02/Helmet-detection.png',
      statusColor: 'danger'
    },
    {
      id: 4,
      name: 'Loading Dock',
      status: 'Online',
      image: 'https://smartclick.ai/wp-content/uploads/2022/02/Helmet-detection.png',
      statusColor: 'success'
    }
  ]

  // Static data for camera feeds
  const alertssData = [
    {
      id: 1,
      name: 'Main Entrance',
      status: 'Online',
      image: 'https://smartclick.ai/wp-content/uploads/2021/08/MicrosoftTeams-image-4.jpg',
      statusColor: 'success'
    },
    {
      id: 2,
      name: 'Warehouse A',
      status: 'Online',
      image: 'https://smartclick.ai/wp-content/uploads/2021/08/MicrosoftTeams-image-4.jpg',
      statusColor: 'success'
    },
    {
      id: 3,
      name: 'Production Line 1',
      status: 'Offline',
      image: 'https://smartclick.ai/wp-content/uploads/2021/08/MicrosoftTeams-image-4.jpg',
      statusColor: 'danger'
    },
    {
      id: 4,
      name: 'Loading Dock',
      status: 'Online',
      image: 'https://smartclick.ai/wp-content/uploads/2021/08/MicrosoftTeams-image-4.jpg',
      statusColor: 'success'
    },

  ]

  return (
    <Container fluid className='dashboard-container'>
      {/* Header */}
      <Row>
        <Col>
          <div className="dashboard-header mb-4">
            <h2 style={{ color: '#1d67aa' }}>Welcome!</h2>
            <h4 style={{ color: '#1d67aa' }}>{filters?.week || filters?.date || filters?.month || filters?.starting + ' To ' + filters?.ending} Data</h4>
            {/* <h4 className="text-muted mb-0">Here are some summary for you to check</h4> */}
          </div>
        </Col>


        <Col xs="12" xl="4" className="d-flex flex-wrap justify-content-end align-items-start mb-2">
          <FiltersComponent
            setFilters={setFilters}
            filtersConfig={[
              { key: "selectDate", options: ["date", "week", 'month', 'custom'], placeholder: "week" },
            ]}
            handleSave={handleSave}
            handleCancel={handleCancel}
            filters={filters}
          />
        </Col>
      </Row>


      {/* Stats Cards */}
      <Row className="mb-2">
        {statsData?.map((stat, index) => (
          <Col xxl={2} lg={3} md={4} sm={6} key={index} className="mb-3 text-center">
            <Card className="stat-card h-100">
              <CardBody className="text-center">
                <div className="stat-icon mb-2">
                  <span style={{ fontSize: '24px' }}>{stat.icon}</span>
                </div>
                <h6 style={{ height: '30px' }} className="stat-title text-muted mb-2">{stat.title}</h6>
                <h2 className="stat-value mb-1">
                  {loadingStats ? <Loader size="md" /> : (statsData.find(s => s.id === stat.id)?.value || stat.value)}
                </h2>
                <small style={{ color: '#1d67aa' }} className="stat-subtitle">{stat.subtitle}</small>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className='mb-4'>
        <WorkPermitSection permitData={permitData} loading={loadingStats} />
      </Row>

      <Row>
        <Col xs='12' xl='6'>

          <AlertTrendChartTalkpool alertTrend={alertTrend} loading={loadingAlertTrend} />
        </Col>
        <Col xs='12' xl='6'>
          <div className="section-header mb-4">
            <h5 style={{ color: '#1d67aa' }} className=" mb-1">Live Camera Feeds</h5>
            <p className="text-muted mb-0">Monitor real-time video streams from your cameras.</p>
          </div>
          <Row>
            {loadingCameras ? (
              // Show skeleton loaders while loading
              Array.from({ length: 2 }).map((_, index) => (
                <Col xs='6' key={index} className="mb-4">
                  <Card className="camera-card h-100">
                    <div className="camera-image-container position-relative d-flex justify-content-center align-items-center" style={{ height: '200px', backgroundColor: '#f8f9fa' }}>
                      <Loader size="lg" />
                    </div>
                    <CardBody className="text-center">
                      <div className="d-flex justify-content-center mb-3">
                        <Loader size="sm" />
                      </div>
                      <button className="btn btn-outline-primary btn-sm" disabled>
                        View Details
                      </button>
                    </CardBody>
                  </Card>
                </Col>
              ))
            ) : (
              camerasData?.map((camera) => (
                <Col xs='6' key={camera.id} className="mb-4">
                  <Card className="camera-card h-100">
                    <div className="camera-image-container position-relative">
                      <img
                        src={camera?.image_url}
                        alt={'Camera Image'}
                        className="camera-image"
                        onError={(e) => {
                          e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNhbWVyYSBGZWVkPC90ZXh0Pjwvc3ZnPg=='
                        }}
                      />
                      <Badge
                        color={camera?.active ? 'success' : 'danger'}
                        className="status-badge position-absolute"
                      >
                        {camera?.active ? 'Online' : 'Offline'}
                      </Badge>
                    </div>
                    <CardBody className="text-center">
                      <h6 className="camera-name mb-3">{camera?.camera_name}</h6>
                      <div className='d-flex flex-column gap-2'>
                        <div className="d-flex justify-content-between">
                          <p className="mb-0">Camera ID</p>
                          <p className="mb-0">{camera.camera_id}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="mb-0">Last Active</p>
                          <p className="mb-0">{camera.last_active}</p>
                        </div>
                        {/* <div className="d-flex justify-content-between">
                        <p className="mb-0">NVR:</p>
                        <p className="mb-0">{camera?.nvr_no}</p>
                      </div> */}
                        <div>
                          <Button
                            color="primary"
                            className="w-100 d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: '#5dade2', borderColor: '#5dade2' }}
                            onClick={() => handleImageClick(camera?.image_url, {
                              cameraId: camera.camera_id,
                              zone: camera.camera_name,
                              detectedDate: camera.last_active?.split('T')[0] || 'N/A',
                              detectedTime: camera.last_active?.split('T')[1]?.split('.')[0] || 'N/A'
                            })}
                          >
                            {/* <i className="fa fa-eye me-2"></i> */}
                            View Details
                          </Button>
                        </div>
                      </div>


                    </CardBody>
                  </Card>
                </Col>
              ))
            )}
          </Row>
        </Col>


      </Row>


      {/* Live Camera Feeds Section */}
      <div className="camera-feeds-section">

        {/* Alerts Data Show */}
        <div className="camera-feeds-section">
          <div className="section-header mb-4">
            <h5 style={{ color: '#1d67aa' }} className=" mb-1">Recent Alerts</h5>
            <p className="text-muted mb-0">Latest safety Incidents and Violations.</p>
          </div>
        </div>
        <Row>
          <AlertsCard alertsData={alertsData} loading={loadingAlerts} handleImageClick={handleImageClick} />
          {alertsData?.length < 1 ? <center style={{}}>
            <AlertCircle color="grey" />
            <h5 className="txt-grey" style={{ color: "grey" }}>
              {"No Alerts to Show"}
            </h5>
          </center> : null}
        </Row>
        <div className="d-flex justify-content-center mt-3">
          <NewPagination
            currentPage={alertsPage}
            totalPages={totalPages}
            onPageChange={setAlertsPage}
          // data={paginatedAlerts}
          />
        </div>
      </div>
      {showModal && (
        <ImageZoomSingleImage
          photo={imageUrl}
          setShowModal={setShowModal}
          cameraDetails={cameraDetails}
        />
      )}
    </Container>


  )
}


export default DefaultDashboard
